import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from "react-router";
import { GlobalProvider } from './shared/context/globalContext.jsx'
import { registerSW } from 'virtual:pwa-register'

// Configurar la actualización del service worker
const updateSW = registerSW({
  immediate: false,
  onNeedRefresh() {
    // Solo actualizar si no hay una sesión activa o si la actualización es crítica
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      updateSW(true);
    }
  },
  onRegistered(swRegistration) {
    if (swRegistration) {
      // Verificar el estado de registro
      if (swRegistration.active) {
        console.log('Service Worker activo');
      }

      // Manejar cambios en el estado del Service Worker
      swRegistration.addEventListener('statechange', (event) => {
        if (event.target.state === 'activated') {
          console.log('Nuevo Service Worker activado');
        }
      });

      // Actualizar el SW cada 6 horas
      setInterval(() => {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
          swRegistration.update().catch(console.error);
        }
      }, 6 * 60 * 60 * 1000);
    }
  },
  onRegisterError(error) {
    console.error('Error durante el registro del SW:', error);
  }
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter> 
      <GlobalProvider>
        <App />
      </GlobalProvider>
    </BrowserRouter>
  </StrictMode>,
)
